import React from 'react';
import './aboutheader.css';
import kermabg from '../../../assets/biggallery/IMG_1028.JPG';

const Bakemenuheader = () => {
  return (
    <div>
      <div className="menu-background-header">
        <img src={kermabg} className="menu-background-image" alt="kerma-background" />
        <div className="header-text">
          <h1 className="tervetoula-kerma">Meistä</h1>
        </div>
      </div>
    </div>
  );
};

export default Bakemenuheader;